<template>
  <a-card :bordered='false' style="width: 100%">
    <div v-show="!stampShowed">
      <div  v-show="!disabled" id="pdfCentent">
        <h1 style="text-align: center">评标基准价随机抽取表</h1>
        <span style="display: block; font-size: 16px">招标编号:{{ tmbidSection.tenderProjectCode }}</span>
        <span style="display: block; font-size: 16px"> 项目名称:{{ tmbidSection.bidSectionName }}</span>

        <span style="font-size: 16px; text-align: center; display: block">第{{ this.extractTimes }}次抽取</span>
        <span style="font-size: 16px; text-align: right; display: block"
          >招标控制价A值:{{ thousandthNumber(this.boOpenConfig.controlPrice )}}元</span
        >
        <a-spin tip="加载中......" :spinning="loadSpin">
          <div style="margin-bottom: 10px;">
            <table>
              <tr>
                <th colspan="2">K1值（%）计算</th>
              </tr>
              <tr>
                <th>
                  第一步
                </th>
                <td>
                  计算 K1 值区间等份数 N 。将每 1 个 K1 值区 间分为 100 个等份 (即步长为 0.01%) ，则 N  (K1 值 区间等份数) =(b-a) %/0.01%。
                </td>
              </tr>
              <tr>
                <th colspan="2">
                  <span style="margin-top: 10px;width: 35%;float: left">
                    N=<a-input-number disabled style="width: 60%;margin-right: 50px;margin-left: 10px;" v-model="Nvalue" />
                    </span>
                  <a-button type="primary" v-if="buttonShow" @click="autoCal('Nvalue')" style="float:right;margin-right: 30px;">自动计算</a-button>
                </th>
              </tr>
              <tr>
                <th>
                  第二步
                </th>
                <td>
                  计算下浮率 取值范围内的投标报价 hi 的累加值H 和对应的投标人数量n。
                </td>
              </tr>
              <tr>
                <th colspan="2">
                  <span  style="margin-top: 10px;width: 35%;float: left"  >
                  H=<a-input-number disabled style="width: 60%;margin-right: 50px;margin-left: 10px;" v-model="Hvalue" />
                </span>
                  <span style="margin-top: 10px;width: 35%;float: left"  >
                  n=<a-input-number disabled style="width: 60%;margin-right: 50px;margin-left: 10px" v-model="nvalue" />
                </span>
                  <a-button type="primary" v-if="buttonShow" @click="autoCal('hn')" style="float:right;margin-right: 30px;">自动计算</a-button>
                  <div style="float:left;margin:10px">
                    报价累加值 H 指 h 1+h2+……+hn (H 值以元为单位精确到元，小数点后第一位“四舍五入”) 。投标人数量 n 指投标报价 hi 下浮率在取值范围内的对应的投标人数量。投标报 价hi 值以元为单位精确到元，小数点后第一位“四舍 五入”。
                  </div>
                </th>
              </tr>
              <tr>
                <th>
                  第三步
                </th>
                <td>
                  求余数Y。被除数=H+n ，除数=N，Y 为被除数 (H+n) 和除数N 的余数。余数 Y 的函数表达式为 Y=MOD(H+n ，N) 。
                </td>
              </tr>
              <tr>
                <th colspan="2">
                  <span style="margin-top: 10px;width: 35%;float: left"  >
                  Y=<a-input-number disabled style="width: 60%;margin-right: 50px;margin-left: 10px" v-model="YValue"  />
                </span>
                  <a-button type="primary" v-if="buttonShow" @click="autoCal('YValue')" style="float:right;margin-right: 30px;">自动计算</a-button>
                </th>
              </tr>
              <tr>
                <th>
                  第四步
                </th>
                <td>
                  计算 K1值。K1值计算式为 K1=Y×0.01%+a%。
                </td>
              </tr>
              <tr>
                <th colspan="2">
                  <span style="margin-top: 10px;width: 35%;float: left"  >
                  K1=<a-input-number disabled style="width: 60%;margin-right: 50px;margin-left: 2px" v-model="kOneShow" /> %
                </span>
                  <a-button type="primary" v-if="buttonShow"  @click="autoCal('kOne')" style="float:right;margin-right: 30px;">自动计算</a-button>
                </th>
              </tr>
            </table>
          </div>

          <table>
            <tr>
              <th style="width: 100px">k2的取值区间</th>
              <td :colspan="this.colspanNum">
                {{ this.boOpenConfig.kvaluemin }}
                %(含)-
                {{ this.boOpenConfig.kvaluemax }}
                %(不含)
              </td>
            </tr>
            <tr>
              <th>---</th>
              <th :colspan="this.colspanNum1">k2值整数位抽取</th>
              <th colspan="10">k2值小数点后第一位数抽取(数值)</th>
              <th colspan="10">k2值小数点后第二位数抽取(数值)</th>
            </tr>
            <tr>
              <th>抽取范围</th>
              <td v-for="(item, i) in kValues" style="width: 40px">
                {{ item }}
              </td>
              <td v-for="(item, i) in list" style="width: 40px">
                {{ item }}
              </td>
              <td v-for="(item, i) in list" style="width: 40px">
                {{ item }}
              </td>
            </tr>
            <tr>
              <th>对应球号</th>
              <td v-for="(item, i) in kValues">
                <input
                class="input_kinteger"
                  type="text"
                  :ref="'input_kinteger_' + item"
                  onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                  maxlength="5"
                  @blur="(e) => leaveKinteger(e.target, item)"
                  style="width: 42px"
                />
              </td>
              <td v-for="(item, i) in list">
                <input
                 class="input_kdecimalFirst"
                  type="text"
                  :ref="'input_kdecimalFirst_' + item"
                  onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                  maxlength="5"
                  @blur="(e) => leavekDecimalFirst(e.target, item)"
                  style="width: 42px"
                />
              </td>
              <td v-for="(item, i) in list">
                <input
                class="input_kdecimalSecond"
                  type="text"
                  :ref="'input_kdecimalSecond_' + item"
                  onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                  maxlength="5"
                  @blur="(e) => leavekDecimalSecond(e.target, item)"
                  style="width: 42px"
                />
              </td>
            </tr>
            <tr>
              <th>抽中球号</th>
              <td :colspan="this.colspanNum1">
                <span
                  ><input
                    :ref="'input_kintegerBall'"
                    type="text"
                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                    maxlength="5"
                    @blur="(e) => leaveKintegerBall(e.target)"
                    style="width: 42px"
                /></span>
              </td>
              <td :colspan="this.list.length">
                <span
                  ><input
                    :ref="'input_kdecimalFirstBall'"
                    type="text"
                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                    maxlength="5"
                    @blur="(e) => leavekDecimalFirstBall(e.target)"
                    style="width: 42px"
                /></span>
              </td>
              <td :colspan="this.list.length">
                <span
                  ><input
                    :ref="'input_kdecimalSecondBall'"
                    type="text"
                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                    maxlength="5"
                    @blur="(e) => leavekDecimalSecondBall(e.target)"
                    style="width: 42px"
                /></span>
              </td>
            </tr>
            <tr>
              <th>对应数值</th>
              <td :colspan="this.colspanNum1">
                <span
                  ><input :ref="'input_kintegerValue'" type="text" readonly="true" style="width: 42px"
                /></span>
              </td>
              <td :colspan="this.list.length">
                <span
                  ><input :ref="'input_kdecimalFirstValue'" type="text" readonly="true" style="width: 42px"
                /></span>
              </td>
              <td :colspan="this.list.length">
                <span
                  ><input :ref="'input_kdecimalSecondValue'" type="text" readonly="true" style="width: 42px"
                /></span>
              </td>
            </tr>
            <tr>
              <th :colspan="this.colspanNum + 1">
                K2值抽取结果 K2值=
                <span style="color: #00A0E9;font-size: 26px">{{ this.kTwo }}</span>
                %
              </th>
            </tr>




            <tr >
              <th>d值抽取范围</th>
              <td v-for="(item, i) in cList" colspan="2">
                {{ item }}
              </td>
            </tr>

          <tr >
            <th>随机号</th>
            <td v-for="(item, i) in cList" colspan="2">
                <input
                 class ="input_crandom"
                  type="text"
                  :ref="'input_crandom_' + item"
                  @blur="(e) => leaveC(e.target,item)"
                  onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                  maxlength="5"
                  style="width: 42px"
                />
              </td>
          </tr>

          <tr>
            <th>抽中随机号</th>
            <td :colspan="this.colspanNum + 1">

            <span
                  ><input
                  class="input_cball"
                    :ref="'input_cball'"
                    type="text"
                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                    maxlength="5"
                    @blur="(e) => leaveCBall(e.target)"
                    style="width: 42px"
                /></span>
              </td>
          </tr>
          <tr>
            <th>抽取结果d值</th>
            <td :colspan="this.colspanNum + 1" >
            <span>
                  <input
                  class = "input_cvalue"
                    :ref="'input_cvalue'"
                    type="text"
                    readonly="true"
                    maxlength="5"
                    style="width: 42px;color: #00A0E9;"
                /></span>
            </td>
          </tr>

            <tr>
              <th :colspan="this.colspanNum + 1">
                Y = <span>{{ this.YValue }}</span>,
                K1 = <span>{{ this.kOne }}</span>
                不可竞争金额C = <span>{{ thousandthNumber(this.noCompetMoney) }}</span>
              </th>
            </tr>

            <tr>
              <th :colspan="this.colspanNum + 1">
                K= <span>{{ this.k }},</span> 评标基准价= <span>{{ thousandthNumberNotFloat(this.standardPrice) }}元</span>
              </th>
            </tr>

            <tr>
              <th :colspan="this.colspanNum + 1">
                评标基准价计算公式为：B=[最高控制价 A-不可竞 争金额 C]×(1-K)+不可竞争金额 C（K 指下浮率，C 指不可竞争金额）。
              </th>
            </tr>
            <tr>
              <th>招标人</th>
              <td :colspan="this.list.length * 2 + this.kValues.length"></td>
            </tr>
            <tr>
              <th>招标代理</th>
              <td :colspan="this.list.length * 2 + this.kValues.length"></td>
            </tr>
          </table>
        </a-spin>
      </div>
      <SignFileShow v-if="disabled" :sectionId='sectionId' :type='pdfParams.type'></SignFileShow>
<!--      <div v-if="disabled" v-html="extractHtml" id="printContent"></div>-->
    </div>
    <h2 align="center" style="margin-top: 10px">
        <span v-show="disabled && !stampShowed"
        ><a-button type="primary" style="margin-right: 10px;margin-right: 10px" @click="reEdit()">重新抽取</a-button></span
        >
      <span v-show="!stampShowed && !disabled && this.extractTimes != 1"
      ><a-button type="primary" style="margin-left: 10px;margin-right: 10px" @click="cancle()">取消</a-button></span
      >
      <SignatureButton
        v-show="!stampShowed"
        ref="SignatureButton"
        :pdf-params="pdfParams"
        :stampShowed="stampShowed"
        :disabled="disabled"
        @sign="sign"
        @signShow="signShow"
      ></SignatureButton>
      <a-button type="primary" style="margin-left: 10px" :disabled="disabled" @click="addExtract()">提交</a-button>
      <a-button type="primary" :disabled="!disabled" style="margin-left: 10px" v-print="'#printContent'">打印</a-button>
    </h2>

    <SignatureComponent
      v-show="stampShowed"
      ref="stamp"
      :pdf-params="pdfParams"
      @checkStampForm="checkStampForm"
      @changeIsStamp="changeIsStamp"
    ></SignatureComponent>

    <SignFileShow-modal ref="modalForm"></SignFileShow-modal>
  </a-card>
</template>

<script>
import { postAction, getAction } from '@api/manage'
import stamp from '@/components/Stamp'
import WorkChangeStamp from '@/components/WorkChangeStamp'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'
import numeral from 'numeral'
import { toHtml }  from '@/utils/htmlUtil'
import SignFileShowModal from '../../modules/SignFileShowModal'
import SignFileShow from "@views/bobidopen/modules/SignFileShow.vue";
export default {
  name: 'WaterConservancyKValueExtractLow',
  components: {SignFileShow, WorkChangeStamp, stamp ,SignatureComponent,SignatureButton,SignFileShowModal},
  mixins: [],
  data() {
    return {
      YValue:null,
      nvalue:null,
      Nvalue:null,
      Hvalue:null,
      kOne:null,
      kOneShow:null,
      kTwo:0,
      buttonShow:true,
      noCompetMoney:0,
      extractCFlag:true,
      url: {},
      extractHtml:'',
      bidProjectId: '',
      tmbidSection: {},
      sectionId: '',
      boOpenConfig: {},
      yResult:{},
      colspanNum: '',
      colspanNum1: '',
      kValues: [],
      loadSpin: true,
      extractTimes: 0,
      boOpenExtractktwoConfig: {},
      kinteger: [], //K值整数位抽取
      maxkValue: 0,
      k: 0,
      minkValue: 0,
      kdecimalFirst: [], //K值小数点第一位抽取
      kdecimalSecond: [], //K值小数点第二位抽取
      cRandom:[],//c值随机号
      list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      cList:[0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9],
      standardPrice: null, // 评标基准价
      standardPriceMin: null, //评标基准价范围min
      standardPriceMax: null, //评标基准价范围max
      disabled: false,
      kIntegerMap: new Map(),
      kDecimalFirstMap: new Map(),
      kDecimalSecondMap: new Map(),
      cMap: new Map(),
      //以下签章需要-----------------------
      isStamp: true,
      pdfParams: {
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: '1',
        sectionId: '1',
        type: 'extractK2',
        typeZh: 'k2值抽取签章',
        htmlTitle: 'k2值抽取签章',
        fp: '4',
        signType:'1'//1:统一CA，2：工改签章
      },
      stampShowed: false,
      // disableMixinCreated: true,
    }
  },
  created() {},
  methods: {
    //自动计算
    autoCal(type)
    {
      this.getYvalue();
      if("Nvalue"===type)
      {
        this.Nvalue=this.yResult.Nvalue;
      }else if("hn"===type)
      {
        if(this.Nvalue===null)
        {
          this.$message.warning('请先计算N值！');
          return;
        }
        this.nvalue=this.yResult.nvalue;
        this.Hvalue=this.yResult.Hvalue;
      }
      else if("YValue"===type)
      {
        if(this.nvalue===null || this.Hvalue===null)
        {
          this.$message.warning('请先计算n值和H值！');
          return;
        }
        this.YValue=(this.nvalue*1+this.Hvalue*1)%(this.Nvalue);
      }
      else if("kOne"===type)
      {
        if(this.YValue===null )
        {
          this.$message.warning('请先计算Y值！');
          return;
        }
        this.kOne=this.toRound(this.YValue*0.01/100+(this.yResult.kDown/100),4);
        this.kOneShow=this.toRound(this.kOne*100,2);
        this.setStandardPrices();
      }

    },
    toRound(num,dec)
    {
      return Math.round(num* Math.pow(10,(dec+2))/100)/Math.pow(10,dec);
    },
    setBidProjectId(id, sectionId) {
      //1.根据招标编号ID获取招标项目信息和项目信息
      this.initData()
      this.sectionId = sectionId
      this.bidProjectId = id
      this.pdfParams.bidProjectId = id
      this.pdfParams.sectionId = sectionId
      //设置本页面标识，用于redis key记录当前页面签章信息
      this.pdfParams.pageId = this.sectionId + "_extractK2_" + new Date().getTime();
      this.getTmBidSection()
      this.getBoOpenConfig()
      this.getExtractTimes()
      this.getYvalue()
    },
    getTmBidSection() {
      getAction('/ebid-ce/boOpenExtractConfig/getTmBidSection', {
        bidProjectId: this.bidProjectId,
        sectionId: this.sectionId,
      }).then((res) => {
        if (res.success) {
          this.tmbidSection = res.result
        }
      })
    },
    getBoOpenConfig() {
      let that = this
      getAction('/ebid-ce/boOpenExtractConfig/getBoOpenConfig', {
        bidProjectId: this.bidProjectId,
        sectionId: this.sectionId,
      }).then((res) => {
        if (res.success) {
          this.boOpenConfig = res.result
          this.noCompetMoney = res.result.noCompetMoney
          this.kValues = []
          var v = parseInt(this.boOpenConfig.kvaluemax) - parseInt(this.boOpenConfig.kvaluemin)
          for (var i = 0; i < v; i++) {
            this.kValues.push(parseInt(this.boOpenConfig.kvaluemin) + parseInt(i))
          }
          this.colspanNum = 20 + this.kValues.length
          this.colspanNum1 = this.kValues.length
          this.loadSpin = false
        }
      })
    },
    getExtractTimes() {
      getAction('/ebid-ce/boOpenExtractktwoConfig/getExtractTimes', {
        bidProjectId: this.bidProjectId,
        sectionId: this.sectionId,
      }).then((res) => {
        if (res.success) {
          if (parseInt(res.result) > 0) {
            this.getBoOpenExtractConfig()
            this.disabled = true
            this.extractTimes = parseInt(res.result)
          } else {
            this.extractTimes = 1
          }
        }
      })
    },
    getYvalue() {
      getAction('/ebid-ce/tmBidder/getY/'+ this.sectionId,{}).then((res) => {
        if (res.success) {
          this.yResult = res.result;
          // this.YValue = res.result.YValue
          // this.kOne = res.result.Kone
        }
      })
    },
    getBoOpenExtractConfig() {
      getAction('/ebid-ce/boOpenExtractktwoConfig/getBoOpenExtractktwoConfig', {
        bidProjectId: this.bidProjectId,
        sectionId: this.sectionId,
      }).then((res) => {
        if (res.success) {
          this.boOpenExtractktwoConfig = res.result
          this.extractHtml = this.boOpenExtractktwoConfig.resultHtml
          this.kTwo = this.boOpenExtractktwoConfig.kvalue
          this.kinteger = JSON.parse(this.boOpenExtractktwoConfig.kinteger)
          this.kdecimalFirst = JSON.parse(this.boOpenExtractktwoConfig.kdecimalFirst)
          this.kdecimalSecond = JSON.parse(this.boOpenExtractktwoConfig.kdecimalSecond)
          this.cRandom = JSON.parse(this.boOpenExtractktwoConfig.crandom)
          let maxK = this.boOpenConfig.kvaluemax
          let minK = this.boOpenConfig.kvaluemin
          this.minkValue = minK
          this.mankValue = maxK
          this.standardPrice = this.toRound(this.boOpenExtractktwoConfig.standPrice,2)
          let b = parseFloat(this.boOpenConfig.controlPrice)
          let kmin = parseFloat(this.minkValue) * 0.01
          let kmax = parseFloat(this.mankValue) * 0.01

        }
      })
    },
    reEdit() {
      this.disabled = false
      this.initData()
      this.extractTimes += 1
    },
    setStandardPrices() {
      let that = this
      let a = this.$refs['input_kintegerValue'].value
      let b = this.$refs['input_kdecimalFirstValue'].value
      let c = this.$refs['input_kdecimalSecondValue'].value
      if(undefined != a && '' != a && undefined != b && '' != b && undefined != c && '' != c )
      {
        this.kTwo = a + '.' + b + c
      }

      if(this.kOneShow ==null)
      {
        this.$message.warning("请先抽取K1值")
        return
      }

      let d=that.$refs['input_cvalue'].value;
      if (undefined != a && '' != a && undefined != b && '' != b && undefined != c && '' != c && undefined != d && '' != d) {
        let bValue = parseFloat(that.boOpenConfig.controlPrice);
        let noCompetMoney= parseFloat(that.boOpenConfig.noCompetMoney);
        d=d*1;
        this.k = this.toRound(this.kOne *  d + this.kTwo*0.01 *  parseFloat(1-d),4);
        that.standardPrice =this.toRound( (bValue-noCompetMoney) * (1- this.k)+noCompetMoney,2);
      }
    },
    cancle() {
      this.disabled = true
      this.setBidProjectId(this.bidProjectId, this.sectionId)
    },
    //输入的对应球号不能重复
    checkBallNum(target, item, map){
      if(target.value){
        let hasValue = false;
        for(let key of map.keys()){
          if(key == item){
            continue;
          }

          if(map.get(key) == target.value){
            hasValue = true;
            break;
          }
        }

        if(hasValue){
          $(target).val("");
          map.delete(item);
        }else{
          map.set(item, target.value);
        }
      }else{
        map.delete(item);
      }
    },
    leaveKinteger(target, item) {
      this.checkBallNum(target, item, this.kIntegerMap);
      //
      let kintegerValue= this.$refs['input_kintegerBall'].value;
      if(kintegerValue!==null && kintegerValue!=='' && target.value == kintegerValue)
      {
        let temp='';
        this.kIntegerMap.forEach(function (value, key) {
          if (target.value == value) {
            temp = key
          }
        })
        this.$refs['input_kintegerValue'].value = temp
      }
    },
    leaveC(target, item) {
      //修改了删除原来
      this.checkBallNum(target, item, this.cMap);

      let cball= this.$refs['input_cball'].value;
      if(cball!==null && cball!=='' && target.value == cball)
      {
        let temp='';
        this.cMap.forEach(function (value, key) {
          if (target.value == value) {
            temp = key
          }
        })
        this.$refs['input_cvalue'].value = temp
      }
    },
    leavekDecimalFirst(target, item) {
      this.checkBallNum(target, item, this.kDecimalFirstMap);

      let kdecimalFirstBall= this.$refs['input_kdecimalFirstBall'].value;
      if(kdecimalFirstBall!==null && kdecimalFirstBall!=='' && target.value == kdecimalFirstBall)
      {
        let temp='';
        this.kDecimalFirstMap.forEach(function (value, key) {
          if (target.value == value) {
            temp = key
          }
        })
        this.$refs['input_kdecimalFirstValue'].value = temp
      }
    },
    leavekDecimalSecond(target, item) {
      this.checkBallNum(target, item, this.kDecimalSecondMap);

      let kdecimalSecondBall= this.$refs['input_kdecimalSecondBall'].value;
      if(kdecimalSecondBall!==null && kdecimalSecondBall!=='' && target.value == kdecimalSecondBall)
      {
        let temp='';
        this.kDecimalSecondMap.forEach(function (value, key) {
          if (target.value == value) {
            temp = key
          }
        })
        this.$refs['input_kdecimalSecondValue'].value = temp
      }
    },
    leaveKintegerBall(target) {
      let temp = ''
      this.kIntegerMap.forEach(function (value, key) {
        if (target.value == value) {
          temp = key
        }
      })
      this.$refs['input_kintegerValue'].value = temp
      this.setStandardPrices();
    },
    leaveCBall(target) {
      let temp = ''
      this.cMap.forEach(function (value, key) {
        if (target.value!=='' && target.value!==null &&target.value == value) {
          temp = key
        }
      })
      this.$refs['input_cvalue'].value = temp
      this.setStandardPrices()
    },
    leavekDecimalFirstBall(target) {
      let temp = ''
      this.kDecimalFirstMap.forEach(function (value, key) {
        if (target.value == value) {
          temp = key
        }
      })
      this.$refs['input_kdecimalFirstValue'].value = temp
      this.setStandardPrices()
    },
    leavekDecimalSecondBall(target) {
      let temp = ''
      this.kDecimalSecondMap.forEach(function (value, key) {
        if (target.value == value) {
          temp = key
        }
      })
      this.$refs['input_kdecimalSecondValue'].value = temp
      this.setStandardPrices()
    },

    isRepeat(arr) {
      var obj = {}
      for (var i in arr) {
        //存在重复值
        if (obj[arr[i]]) return true
        obj[arr[i]] = true
      }
      //不重复
      return false
    },
    initData() {
      this.k = null
      this.standardPrice = null
      this.standardPriceMin = null
      this.standardPriceMax = null
	    $(".input_kinteger").val('')
      $(".input_kdecimalFirst").val('')
      $(".input_kdecimalSecond").val('')
      this.$refs['input_kintegerBall'].value = ''
      this.$refs['input_kdecimalFirstBall'].value = ''
      this.$refs['input_kdecimalSecondBall'].value = ''
      this.$refs['input_kintegerValue'].value = ''
      this.$refs['input_kdecimalFirstValue'].value = ''
      this.$refs['input_kdecimalSecondValue'].value = ''
      $(".input_crandom").val('')
      $(".input_cball").val('')
      $(".input_cvalue").val('')
      this.kIntegerMap= new Map();
      this.kDecimalFirstMap=new Map();
      this.kDecimalSecondMap=new Map();
      this.cMap=new Map();
    },
    /**
     * 签章入围企业
     */
    sign(type) {
      this.setStandardPrices();
      let a = this.$refs['input_kintegerValue'].value
      let b = this.$refs['input_kdecimalFirstValue'].value
      let c = this.$refs['input_kdecimalSecondValue'].value
      let d=this.$refs['input_cvalue'].value;
      if (this.k==null||this.kOneShow ==null ||(undefined == a || '' == a || a==null ) ||(undefined == b || '' == b  || b==null ) ||(undefined == c || '' == c || c==null )||( undefined == d || '' == d || d==null )) {
        this.$message.warning("请补充抽取数据完整")
        return;
      }
      let that = this
      let params = {}
      let kinteger = []
      let kdecimalFirst = []
      let kdecimalSecond = []
      let cRandom = []
      let kInputs = []
      let kFirstInputs = []
      let kSecondInputs = []
      let cInputs = []
      for (let i = 0; i < that.kValues.length; i++) {
        let kInput = this.$refs['input_kinteger_' + that.kValues[i]][0].value
        if (undefined != kInput && '' != kInput) {
          let a = { key: that.kValues[i], value: kInput }
          kinteger.push(a)
          kInputs.push(kInput)
        }
      }
      for (let i = 0; i < that.list.length; i++) {
        let kFirstInput = this.$refs['input_kdecimalFirst_' + that.list[i]][0].value
        let kSecondInput = this.$refs['input_kdecimalSecond_' + that.list[i]][0].value
        if (undefined != kFirstInput && '' != kFirstInput) {
          let a = { key: that.list[i], value: kFirstInput }
          kdecimalFirst.push(a)
          kFirstInputs.push(kFirstInput)
        }
        if (undefined != kSecondInput && '' != kSecondInput) {
          let b = { key: that.list[i], value: kSecondInput }
          kdecimalSecond.push(b)
          kSecondInputs.push(kSecondInput)
        }
      }
      for(let i = 0;i<that.cList.length;i++){
        let cInput = that.$refs['input_crandom_' + that.cList[i]][0].value
        if (undefined != cInput && '' != cInput) {
          let a = { key: that.cList[i], value: cInput }
          cRandom.push(a)
          cInputs.push(cInput)
        }
      }


      //必填校验
      if (kinteger.length != this.kValues.length) {
        this.$message.error('请填写k2值整数位抽取对应球号!')
        return
      }
      if (kdecimalFirst.length != this.list.length) {
        this.$message.error('请填写k2值小数点后第一位数抽取(数值)对应球号!')
        return
      }
      if (kdecimalSecond.length != this.list.length) {
        this.$message.error('请填写k2值小数点后第二位数抽取(数值)对应球号!')
        return
      }
      //判断是否重复对应球号
      if (this.isRepeat(kInputs)) {
        this.$message.error('k2值整数位抽取对应球号不能重复!')
        return
      }
      if (this.isRepeat(kFirstInputs)) {
        this.$message.error('k2值小数点后第一位数抽取(数值)对应球号不能重复!')
        return
      }
      if (this.isRepeat(kSecondInputs)) {
        this.$message.error('k2值小数点后第二位数抽取(数值)对应球号不能重复!')
        return
      }
      let kintegerBall = this.$refs['input_kintegerBall'].value
      let kdecimalFirstBall = this.$refs['input_kdecimalFirstBall'].value
      let kdecimalSecondBall = this.$refs['input_kdecimalSecondBall'].value

      if (undefined == kintegerBall || '' == kintegerBall) {
        this.$message.error('请填写k2值整数位抽取抽中球号!')
        return
      }
      if (undefined == kdecimalFirstBall || '' == kdecimalFirstBall) {
        this.$message.error('请填写k2值小数点后第一位数抽取(数值)抽中球号!')
        return
      }
      if (undefined == kdecimalSecondBall || '' == kdecimalSecondBall) {
        this.$message.error('请填写k2值小数点后第二位数抽取(数值)抽中球号!')
        return
      }

      let kintegerValue = 0
      let kdecimalFirstValue = 0
      let kdecimalSecondValue = 0

      var kintegerBallFlag = false
      for (let i = 0; i < kinteger.length; i++) {
        if (kintegerBall == kinteger[i].value) {
          kintegerBallFlag = true
          kintegerValue = kinteger[i].key
          break
        }
      }
      if (!kintegerBallFlag) {
        this.$message.error('k2值整数位抽取抽中球号需在对应球号范围内!')
        return
      }
      var kdecimalFirstBallFlag = false
      for (let i = 0; i < kdecimalFirst.length; i++) {
        if (kdecimalFirstBall == kdecimalFirst[i].value) {
          kdecimalFirstBallFlag = true
          kdecimalFirstValue = kdecimalFirst[i].key
          break
        }
      }
      if (!kdecimalFirstBallFlag) {
        this.$message.error('k2值小数点后第一位数抽取(数值)抽中球号需在对应球号范围内!')
        return
      }

      var kdecimalSecondBallFlag = false
      for (let i = 0; i < kdecimalSecond.length; i++) {
        if (kdecimalSecondBall == kdecimalSecond[i].value) {
          kdecimalSecondBallFlag = true
          kdecimalSecondValue = kdecimalSecond[i].key
          break
        }
      }
      if (!kdecimalSecondBallFlag) {
        this.$message.error('k2值小数点后第二位数抽取(数值)抽中球号需在对应球号范围内!')
        return
      }

      if(this.extractCFlag){
        //C值非空检验
        let num = 0
        let that = this

        if(that.$refs['input_cball'].value==''||that.$refs['input_cball'].value==undefined){
          this.$message.error('请选择d值抽中随机号!')
          return
        }
        let checkCflag=false;
        for (let key of this.cMap.keys()) {
          if (this.cMap.get(key) == that.$refs['input_cball'].value) {
            checkCflag=true;
          }
        }
        if(!checkCflag)
        {
          this.$message.error('请选择正确的d值抽中随机号!')
          return
        }
        if (this.isRepeat(cInputs)) {
          this.$message.error('d值抽中随机号不能重复!')
          return
        }
      }

      this.pdfParams.signType = type;

      this.$confirm({
        title: '提示',
        content: '您确定要进行签章操作吗？',
        onOk() {

          that.$refs.stamp.checkStamp()
        },
        onCancel(){
          that.pdfParams.pageId="";
          that.pdfParams.signedPdfUrl="";
          that.stampShowed = false;
          that.$refs.stamp.pdfUrl=null;
        },
      })
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    },
    //重新编辑
    reWrite(){
      this.pdfParams.pageId="";
      this.pdfParams.signedPdfUrl="";
      this.stampShowed = false;
      this.$refs.stamp.pdfUrl=null;
    },

    checkStampForm(callback) {
      callback(true)
    },
    addExtract() {
      let that = this
      let params = {}
      let kinteger = []
      let kdecimalFirst = []
      let kdecimalSecond = []
      let cRandom = []
      let kInputs = []
      let kFirstInputs = []
      let kSecondInputs = []
      let cInputs = []
      for (let i = 0; i < that.kValues.length; i++) {
        let kInput = this.$refs['input_kinteger_' + that.kValues[i]][0].value
        if (undefined != kInput && '' != kInput) {
          let a = { key: that.kValues[i], value: kInput }
          kinteger.push(a)
          kInputs.push(kInput)
        }
      }
      for (let i = 0; i < that.list.length; i++) {
        let kFirstInput = this.$refs['input_kdecimalFirst_' + that.list[i]][0].value
        let kSecondInput = this.$refs['input_kdecimalSecond_' + that.list[i]][0].value
        if (undefined != kFirstInput && '' != kFirstInput) {
          let a = { key: that.list[i], value: kFirstInput }
          kdecimalFirst.push(a)
          kFirstInputs.push(kFirstInput)
        }
        if (undefined != kSecondInput && '' != kSecondInput) {
          let b = { key: that.list[i], value: kSecondInput }
          kdecimalSecond.push(b)
          kSecondInputs.push(kSecondInput)
        }
      }
        for(let i = 0;i<that.cList.length;i++){
        let cInput = that.$refs['input_crandom_' + that.cList[i]][0].value
        if (undefined != cInput && '' != cInput) {
          let a = { key: that.cList[i], value: cInput }
          cRandom.push(a)
          cInputs.push(cInput)
        }
    }


      //必填校验
      if (kinteger.length != this.kValues.length) {
        this.$message.error('请填写k2值整数位抽取对应球号!')
        return
      }
      if (kdecimalFirst.length != this.list.length) {
        this.$message.error('请填写k2值小数点后第一位数抽取(数值)对应球号!')
        return
      }
      if (kdecimalSecond.length != this.list.length) {
        this.$message.error('请填写k2值小数点后第二位数抽取(数值)对应球号!')
        return
      }
      //判断是否重复对应球号
      if (this.isRepeat(kInputs)) {
        this.$message.error('k2值整数位抽取对应球号不能重复!')
        return
      }
      if (this.isRepeat(kFirstInputs)) {
        this.$message.error('k2值小数点后第一位数抽取(数值)对应球号不能重复!')
        return
      }
      if (this.isRepeat(kSecondInputs)) {
        this.$message.error('k2值小数点后第二位数抽取(数值)对应球号不能重复!')
        return
      }
      let kintegerBall = this.$refs['input_kintegerBall'].value
      let kdecimalFirstBall = this.$refs['input_kdecimalFirstBall'].value
      let kdecimalSecondBall = this.$refs['input_kdecimalSecondBall'].value

      if (undefined == kintegerBall || '' == kintegerBall) {
        this.$message.error('请填写k2值整数位抽取抽中球号!')
        return
      }
      if (undefined == kdecimalFirstBall || '' == kdecimalFirstBall) {
        this.$message.error('请填写k2值小数点后第一位数抽取(数值)抽中球号!')
        return
      }
      if (undefined == kdecimalSecondBall || '' == kdecimalSecondBall) {
        this.$message.error('请填写k2值小数点后第二位数抽取(数值)抽中球号!')
        return
      }

      let kintegerValue = 0
      let kdecimalFirstValue = 0
      let kdecimalSecondValue = 0

      var kintegerBallFlag = false
      for (let i = 0; i < kinteger.length; i++) {
        if (kintegerBall == kinteger[i].value) {
          kintegerBallFlag = true
          kintegerValue = kinteger[i].key
          break
        }
      }
      if (!kintegerBallFlag) {
        this.$message.error('k2值整数位抽取抽中球号需在对应球号范围内!')
        return
      }
      var kdecimalFirstBallFlag = false
      for (let i = 0; i < kdecimalFirst.length; i++) {
        if (kdecimalFirstBall == kdecimalFirst[i].value) {
          kdecimalFirstBallFlag = true
          kdecimalFirstValue = kdecimalFirst[i].key
          break
        }
      }
      if (!kdecimalFirstBallFlag) {
        this.$message.error('k2值小数点后第一位数抽取(数值)抽中球号需在对应球号范围内!')
        return
      }

      var kdecimalSecondBallFlag = false
      for (let i = 0; i < kdecimalSecond.length; i++) {
        if (kdecimalSecondBall == kdecimalSecond[i].value) {
          kdecimalSecondBallFlag = true
          kdecimalSecondValue = kdecimalSecond[i].key
          break
        }
      }
      if (!kdecimalSecondBallFlag) {
        this.$message.error('k2值小数点后第二位数抽取(数值)抽中球号需在对应球号范围内!')
        return
      }

      if(this.extractCFlag){
        //C值非空检验
        let num = 0
        let that = this

        if(that.$refs['input_cball'].value==''||that.$refs['input_cball'].value==undefined){
          this.$message.error('请选择d值抽中随机号!')
          return
        }
        if (this.isRepeat(cInputs)) {
          this.$message.error('d值抽中随机号不能重复!')
          return
        }
      }

      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先签章')
        return
      }

      this.$confirm({
        title: '提示',
        content: '您确定要提交K2/d值抽取吗',
        onOk() {
          params.bidProjectId = that.bidProjectId
          params.sectionId = that.sectionId
          params.ktwoInteger = JSON.stringify(kinteger)
          params.ktwoDecimalFirst = JSON.stringify(kdecimalFirst)
          params.ktwoDecimalSecond = JSON.stringify(kdecimalSecond)
            params.drandom = JSON.stringify(cRandom)
            params.dvalue = that.$refs['input_cvalue'].value
            params.drandomBall = that.$refs['input_cball'].value
          params.ktwoIntegerBall = kintegerBall
          params.ktwoDecimalFirstBall = kdecimalFirstBall
          params.ktwoDecimalSecondBall = kdecimalSecondBall
          params.ktwoIntegerValue = kintegerValue
          params.ktwoDecimalFirstValue = kdecimalFirstValue
          params.ktwoDecimalSecondValue = kdecimalSecondValue
          params.pdfUrl = that.$refs.stamp.getPdfUrl()
          params.type = that.pdfParams.type
          params.typeZh = that.pdfParams.typeZh
          params.resultHtml =  toHtml('pdfCentent')
          params.standPrice = that.standardPrice
          console.log(params)
          postAction('/ebid-ce/boOpenExtractktwoConfig/add', params).then((res) => {
            if (res.success) {
              that.$message.success(res.result)
              that.setBidProjectId(that.bidProjectId, that.sectionId)
            }
          })
        },
      })
    },
    changeIsStamp(val) {
      this.stampShowed = val
    },
    /**
     * 千分位数字
     * @param num
     */
    thousandthNumber(num){
      if(num==null)
      {
        return null;
      }
      return numeral(num).format('0,0.00')
    },
    thousandthNumberNotFloat(num){
      if(num==null)
      {
        return null;
      }
      return numeral(num).format('0,0')
    }
  },
}
</script>

<style scoped>
@import '~@assets/less/common.less';

table,
table tr th,
table tr td {
  border: 1px solid #000;
  text-align: center;
}

th {
  padding-left: 10px;
  font-weight: normal;
  padding-top: 10px;
  padding-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

input {
  text-align: center;
  border-bottom: 1px solid #000;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  outline: none;
}
.ant-input-disabled {
  color: #000; /* 将字体颜色改为红色 */
}
.ant-input-number-disabled  {
  color: #000; /* 将字体颜色改为红色 */
}
</style>